import {
  BarChartOutlined,
  CheckCircleOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import { useFeatureEntitlements } from '@frontegg/react';
import { AppNavMenu } from '..';
import { useDemoStore } from 'src/pages/root/demo/store';
import {
  useCallQaNavAccess,
  usePhoneTriageFullAccess,
} from './usePhoneTriageAccess';

export const usePhoneTriageNavMenus = (): AppNavMenu[] => {
  const { isEntitled: isPhoneTriageDemoEntitled } =
    useFeatureEntitlements('phone-triage-demo');
  const canFullPhone = usePhoneTriageFullAccess();
  const showCallQa = useCallQaNavAccess();

  const { setDemoStoreState } = useDemoStore();

  if (canFullPhone) {
    return [
      {
        path: '/phone-triage/calls',
        title: 'Phone',
        icon: <PhoneOutlined />,
        submenu: [
          {
            path: '/phone-triage/analytics',
            title: 'Analytics',
            icon: <BarChartOutlined />,
          },
          ...(showCallQa
            ? [
                {
                  path: '/phone-triage/call-qa',
                  title: 'Call QA',
                  icon: <CheckCircleOutlined />,
                },
              ]
            : []),
        ],
      },
    ];
  }

  if (showCallQa) {
    return [
      {
        path: '/phone-triage/call-qa',
        title: 'Call QA',
        icon: <CheckCircleOutlined />,
      },
    ];
  }

  if (isPhoneTriageDemoEntitled) {
    return [
      {
        path: '',
        title: 'Phone',
        icon: <PhoneOutlined />,
        onClick: () => {
          setDemoStoreState({ showPhoneTriageDemo: true });
        },
        showBadge: 'dot',
      },
    ];
  }

  return [];
};
